// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file ga/bo/user_scope/user_scope.proto (package ga.bo.user_scope, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ga/bo/user_scope/user_scope.proto.
 */
export const file_ga_bo_user_scope_user_scope: GenFile = /*@__PURE__*/
  fileDesc("CiFnYS9iby91c2VyX3Njb3BlL3VzZXJfc2NvcGUucHJvdG8SEGdhLmJvLnVzZXJfc2NvcGUiIAoPR2V0VXNlclNjb3BlUmVxEg0KBXRva2VuGAEgASgJIj4KEEdldFVzZXJTY29wZVJlc3ASKgoFc2NvcGUYASABKAsyGy5nYS5iby51c2VyX3Njb3BlLlVzZXJTY29wZSLnAwoJVXNlclNjb3BlEg8KB3VzZXJfaWQYASABKAkSDQoFZW1haWwYAiABKAkSEQoJdXNlcl90eXBlGAMgASgJEhUKDWlzX3N1cGVyX3VzZXIYBCABKAgSLQoHY29tcGFueRgFIAEoCzIcLmdhLmJvLnVzZXJfc2NvcGUuQ29tcGFueVJlZhIoCgV0ZWFtcxgGIAMoCzIZLmdhLmJvLnVzZXJfc2NvcGUuVGVhbVJlZhIoCgRyb2xlGAcgASgLMhouZ2EuYm8udXNlcl9zY29wZS5Sb2xlSW5mbxITCgtwZXJtaXNzaW9ucxgIIAMoCRIwCgZkaXJlY3QYCSABKAsyIC5nYS5iby51c2VyX3Njb3BlLlJlc291cmNlQWNjZXNzEjIKCGV4dGVuZGVkGAogASgLMiAuZ2EuYm8udXNlcl9zY29wZS5SZXNvdXJjZUFjY2VzcxIrCgVhZG1pbhgLIAEoCzIcLmdhLmJvLnVzZXJfc2NvcGUuQWRtaW5TY29wZRIzChBhc3NpZ25hYmxlX3JvbGVzGAwgAygLMhkuZ2EuYm8udXNlcl9zY29wZS5Sb2xlUmVmEjAKDXZpc2libGVfcm9sZXMYDSADKAsyGS5nYS5iby51c2VyX3Njb3BlLlJvbGVSZWYiUwoOUmVzb3VyY2VBY2Nlc3MSEgoKY2FzaW5vX2lkcxgBIAMoCRIbChNnYW1lX3Byb3ZpZGVyX25hbWVzGAIgAygJEhAKCHVzZXJfaWRzGAMgAygJIjwKCkNvbXBhbnlSZWYSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRIUCgxjb21wYW55X3R5cGUYAyABKAkiIwoHVGVhbVJlZhIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJIjcKCFJvbGVJbmZvEgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkSEQoJdXNlcl90eXBlGAMgASgJIjYKB1JvbGVSZWYSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRIRCgl1c2VyX3R5cGUYAyABKAkiOwoKQWRtaW5TY29wZRITCgtjb21wYW55X2lkcxgBIAMoCRIYChBjb21wYW55X3RlYW1faWRzGAIgAygJMmkKEFVzZXJTY29wZVNlcnZpY2USVQoMR2V0VXNlclNjb3BlEiEuZ2EuYm8udXNlcl9zY29wZS5HZXRVc2VyU2NvcGVSZXEaIi5nYS5iby51c2VyX3Njb3BlLkdldFVzZXJTY29wZVJlc3BCxQEKFGNvbS5nYS5iby51c2VyX3Njb3BlQg5Vc2VyU2NvcGVQcm90b1ABWj94ZGV2dGVhbS5jb20vYThyL2NvbmZpZy1tYW5hZ2VyL2ludGVybmFsL3Byb3RvL2dhL2JvL3VzZXJfc2NvcGWiAgNHQlWqAg9HYS5Cby5Vc2VyU2NvcGXKAg9HYVxCb1xVc2VyU2NvcGXiAhtHYVxCb1xVc2VyU2NvcGVcR1BCTWV0YWRhdGHqAhFHYTo6Qm86OlVzZXJTY29wZWIGcHJvdG8z");

/**
 * @generated from message ga.bo.user_scope.GetUserScopeReq
 */
export type GetUserScopeReq = Message<"ga.bo.user_scope.GetUserScopeReq"> & {
  /**
   * Session token from auth cookie/header.
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message ga.bo.user_scope.GetUserScopeReq.
 * Use `create(GetUserScopeReqSchema)` to create a new message.
 */
export const GetUserScopeReqSchema: GenMessage<GetUserScopeReq> = /*@__PURE__*/
  messageDesc(file_ga_bo_user_scope_user_scope, 0);

/**
 * @generated from message ga.bo.user_scope.GetUserScopeResp
 */
export type GetUserScopeResp = Message<"ga.bo.user_scope.GetUserScopeResp"> & {
  /**
   * @generated from field: ga.bo.user_scope.UserScope scope = 1;
   */
  scope?: UserScope;
};

/**
 * Describes the message ga.bo.user_scope.GetUserScopeResp.
 * Use `create(GetUserScopeRespSchema)` to create a new message.
 */
export const GetUserScopeRespSchema: GenMessage<GetUserScopeResp> = /*@__PURE__*/
  messageDesc(file_ga_bo_user_scope_user_scope, 1);

/**
 * @generated from message ga.bo.user_scope.UserScope
 */
export type UserScope = Message<"ga.bo.user_scope.UserScope"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string user_type = 3;
   */
  userType: string;

  /**
   * @generated from field: bool is_super_user = 4;
   */
  isSuperUser: boolean;

  /**
   * @generated from field: ga.bo.user_scope.CompanyRef company = 5;
   */
  company?: CompanyRef;

  /**
   * @generated from field: repeated ga.bo.user_scope.TeamRef teams = 6;
   */
  teams: TeamRef[];

  /**
   * @generated from field: ga.bo.user_scope.RoleInfo role = 7;
   */
  role?: RoleInfo;

  /**
   * @generated from field: repeated string permissions = 8;
   */
  permissions: string[];

  /**
   * Team-scoped resources.
   *
   * @generated from field: ga.bo.user_scope.ResourceAccess direct = 9;
   */
  direct?: ResourceAccess;

  /**
   * Company-scoped resources (read-only).
   *
   * @generated from field: ga.bo.user_scope.ResourceAccess extended = 10;
   */
  extended?: ResourceAccess;

  /**
   * @generated from field: ga.bo.user_scope.AdminScope admin = 11;
   */
  admin?: AdminScope;

  /**
   * @generated from field: repeated ga.bo.user_scope.RoleRef assignable_roles = 12;
   */
  assignableRoles: RoleRef[];

  /**
   * @generated from field: repeated ga.bo.user_scope.RoleRef visible_roles = 13;
   */
  visibleRoles: RoleRef[];
};

/**
 * Describes the message ga.bo.user_scope.UserScope.
 * Use `create(UserScopeSchema)` to create a new message.
 */
export const UserScopeSchema: GenMessage<UserScope> = /*@__PURE__*/
  messageDesc(file_ga_bo_user_scope_user_scope, 2);

/**
 * @generated from message ga.bo.user_scope.ResourceAccess
 */
export type ResourceAccess = Message<"ga.bo.user_scope.ResourceAccess"> & {
  /**
   * @generated from field: repeated string casino_ids = 1;
   */
  casinoIds: string[];

  /**
   * @generated from field: repeated string game_provider_names = 2;
   */
  gameProviderNames: string[];

  /**
   * @generated from field: repeated string user_ids = 3;
   */
  userIds: string[];
};

/**
 * Describes the message ga.bo.user_scope.ResourceAccess.
 * Use `create(ResourceAccessSchema)` to create a new message.
 */
export const ResourceAccessSchema: GenMessage<ResourceAccess> = /*@__PURE__*/
  messageDesc(file_ga_bo_user_scope_user_scope, 3);

/**
 * @generated from message ga.bo.user_scope.CompanyRef
 */
export type CompanyRef = Message<"ga.bo.user_scope.CompanyRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string company_type = 3;
   */
  companyType: string;
};

/**
 * Describes the message ga.bo.user_scope.CompanyRef.
 * Use `create(CompanyRefSchema)` to create a new message.
 */
export const CompanyRefSchema: GenMessage<CompanyRef> = /*@__PURE__*/
  messageDesc(file_ga_bo_user_scope_user_scope, 4);

/**
 * @generated from message ga.bo.user_scope.TeamRef
 */
export type TeamRef = Message<"ga.bo.user_scope.TeamRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message ga.bo.user_scope.TeamRef.
 * Use `create(TeamRefSchema)` to create a new message.
 */
export const TeamRefSchema: GenMessage<TeamRef> = /*@__PURE__*/
  messageDesc(file_ga_bo_user_scope_user_scope, 5);

/**
 * @generated from message ga.bo.user_scope.RoleInfo
 */
export type RoleInfo = Message<"ga.bo.user_scope.RoleInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string user_type = 3;
   */
  userType: string;
};

/**
 * Describes the message ga.bo.user_scope.RoleInfo.
 * Use `create(RoleInfoSchema)` to create a new message.
 */
export const RoleInfoSchema: GenMessage<RoleInfo> = /*@__PURE__*/
  messageDesc(file_ga_bo_user_scope_user_scope, 6);

/**
 * @generated from message ga.bo.user_scope.RoleRef
 */
export type RoleRef = Message<"ga.bo.user_scope.RoleRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string user_type = 3;
   */
  userType: string;
};

/**
 * Describes the message ga.bo.user_scope.RoleRef.
 * Use `create(RoleRefSchema)` to create a new message.
 */
export const RoleRefSchema: GenMessage<RoleRef> = /*@__PURE__*/
  messageDesc(file_ga_bo_user_scope_user_scope, 7);

/**
 * @generated from message ga.bo.user_scope.AdminScope
 */
export type AdminScope = Message<"ga.bo.user_scope.AdminScope"> & {
  /**
   * @generated from field: repeated string company_ids = 1;
   */
  companyIds: string[];

  /**
   * @generated from field: repeated string company_team_ids = 2;
   */
  companyTeamIds: string[];
};

/**
 * Describes the message ga.bo.user_scope.AdminScope.
 * Use `create(AdminScopeSchema)` to create a new message.
 */
export const AdminScopeSchema: GenMessage<AdminScope> = /*@__PURE__*/
  messageDesc(file_ga_bo_user_scope_user_scope, 8);

/**
 * @generated from service ga.bo.user_scope.UserScopeService
 */
export const UserScopeService: GenService<{
  /**
   * @generated from rpc ga.bo.user_scope.UserScopeService.GetUserScope
   */
  getUserScope: {
    methodKind: "unary";
    input: typeof GetUserScopeReqSchema;
    output: typeof GetUserScopeRespSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ga_bo_user_scope_user_scope, 0);

